import cx from 'classnames'

import { type SanityTeamMember } from '@data/sanity/queries/types/blocks'

import TeamMemberCard from '@blocks/team-member-card'

interface TeamMembersGridProps {
  title?: string
  subtitle?: string
  teamMembers?: SanityTeamMember[]
}

const TeamMembersGrid = ({
  title,
  subtitle,
  teamMembers,
}: TeamMembersGridProps) => {
  const gridGapClasses = 'gap-x-4 gap-y-8 sm:gap-x-8 lg:gap-x-12 lg:gap-y-12'

  return (
    <section className="bg-gray-light text-green-dark">
      <div className="relative container py-12 sm:py-16 md:py-24 lg:py-32">
        <div
          className={cx(
            'mt-8 lg:mt-12 grid grid-cols-3 lg:grid-cols-4',
            gridGapClasses,
          )}
        >
          <div className="col-span-3 lg:col-span-1">
            {subtitle && <p> {subtitle}</p>}
            {title && <h3>{title}</h3>}
          </div>

          {teamMembers && teamMembers.length > 0 && (
            <div
              className={cx(
                'col-span-3 grid grid-cols-2 sm:grid-cols-3',
                gridGapClasses,
              )}
            >
              {teamMembers
                .filter((teamMember) => teamMember)
                .map((teamMember, index) => (
                  <TeamMemberCard
                    key={`team-members-grid-${index}-${teamMember.slug.current}`}
                    teamMember={teamMember}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default TeamMembersGrid
